import { FieldErrors } from 'react-hook-form';

import { EditEventStepVariant } from '../event-form.types';
import { FormSchema } from '../event-form.validation';

// The base edit wizard validates one schema across all of its steps, so a submit can fail on a
// field the current step does not render — closing a fundraising round from the events list lands
// on step 1 with an empty closing date, and the duplicate-round "click here" link jumps to the
// investments step, where Update then failed with "fix the highlighted fields" and nothing
// highlighted. Send the user to the step that owns the first failing field instead.
const BASE_EDIT_STEP_BY_ERROR_ROOT: [keyof FormSchema, EditEventStepVariant][] = [
  ['stepOne', 1],
  ['optionalStep', 2],
  ['stepTwo', 3],
];

export const resolveInvalidBaseEditStep = (
  errors: FieldErrors<FormSchema>,
): EditEventStepVariant | null =>
  BASE_EDIT_STEP_BY_ERROR_ROOT.find(([root]) => !!errors[root])?.[1] ?? null;
